import React from 'react'
import PropTypes from 'prop-types'
import { l } from '@manychat/manyui'

import ConnectorPoint from 'common/builder/components/chart/FlowChart/nodes/shared/ConnectorPoint'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import Connector from 'common/builder/controllers/chart/FlowChart/nodes/shared/Connector'

const textStyle = {
  ...sharedStyles.text,
  ...sharedStyles.textSecondary,
  flexGrow: 1,
  marginRight: '20px',
  textAlign: 'right',
}

export default class NextStep extends React.PureComponent {
  static propTypes = {
    connectorOffsetX: PropTypes.number,
    dotColor: PropTypes.string,
    hidden: PropTypes.bool,
    sourceId: PropTypes.string,
    style: PropTypes.object,
    text: PropTypes.node,
    width: PropTypes.number,
    textStyle: PropTypes.object,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
  }

  static defaultProps = {
    style: {},
    connectorOffsetX: 0,
    textStyle: {},
  }

  render() {
    const { sourceId, connectorOffsetX, textStyle: externalTextStyle, disabled } = this.props
    const { dotColor, hidden, style, tooltip } = this.props
    const text = this.props.text ?? l.translate('Next Step')
    const hasText = Boolean(text)

    return (
      <view
        style={{
          display: 'flex',
          alignItems: 'center',
          ...style,
        }}
      >
        {hasText && <richtext style={{ ...textStyle, ...externalTextStyle }} text={text} />}
        <ConnectorPoint id={sourceId} />
        {!hidden && (
          <Connector
            sourceId={sourceId}
            offsetX={connectorOffsetX}
            color={dotColor}
            disabled={disabled}
            tooltip={tooltip}
          />
        )}
      </view>
    )
  }
}
